import Vue from "vue"
import store from '@/store'
import Router from "vue-router"
import Login from "@/views/Account/Login"
import Maintenance from "@/views/Account/Maintenance"
import LoginOnce from "@/views/Account/LoginOnce/LoginOnce"
import Dashboard from "@/views/Dashboard/Dashboard"
import AdminUsers from "@/views/Admin/Listing/AdminUsers"
import SecretaryUsers from "@/views/Admin/Listing/SecretaryUsers"
import AdminRegister from "@/views/Admin/Register/Register"
import Members from "@/views/Members/Listing/Members"
import MemberJoin from "@/views/Members/Join/MemberJoin"
import MemberProfileMembers from "@/views/Members/Profile/MemberProfileMembers"
import MemberProfileChild from "@/views/Members/Profile/MemberProfileChild"
import MemberMerge from "@/views/Members/Merge/MemberMerge"
import MemberSplit from "@/views/Members/Profile/MemberSplit"
import PendingInvoices from "@/views/Admin/Pending/PendingInvoices"
import PendingRegistrations from "@/views/Admin/Pending/PendingRegistrations"
import PendingHorse from "@/views/Admin/Pending/Horse/Horse"
import AdminProfile from "@/views/Admin/Profile/AdminProfile"
import SecretaryProfile from "@/views/Admin/Profile/SecretaryProfile"
import AdminProfileChild from "@/views/Admin/Profile/AdminProfileChild"
import MyMembershipProfile from "@/views/MyMembership/MyMembershipProfile"
import MyMembershipProfileChild from "@/views/MyMembership/MyMembershipProfileChild"
import MyMembershipCart from "@/views/MyMembership/MyMembershipCart"
import MyMembershipPayment from "@/views/MyMembership/MyMembershipPayment"
import MemberAdd from "@/views/MyMembership/Add/MemberAdd"
import MemberAdminAdd from "@/views/Admin/Add/AdminAdd"
import SecretaryAdd from "@/views/Admin/Add/SecretaryAdd"
import CommitteeList from "@/views/Committees/Listing/Committees"
import SwitchCommittee from "@/views/Committees/Switch/SwitchCommittee"
import CommitteeProfile from "@/views/Committees/Profile/CommitteeProfile"
import HorsesListing from "@/views/Horses/Listing/HorsesListing"
import HorseProfile from "@/views/Horses/Profile/HorseProfile"
import HorseAdd from "@/views/Horses/Add/HorseAdd"
import HorseRegister from "@/views/Horses/Register/HorseRegister"
import RookieNominations from "@/views/Horses/Nominate/NominateRookie"
import HorseConfirm from "@/views/Horses/Register/HorseRegisterConfirm"
import HorseRegisterCart from "@/views/Horses/Cart/Cart"
import HorseRegisterPayment from "@/views/Horses/Cart/Payment"
import DraftsList from "@/views/Drafts/Listing/Drafts"
import DraftCreate from "@/views/Drafts/Add/DraftAdd"
import EventsList from "@/views/Drafts/Events/Listing/Events"
import EventCreate from "@/views/Drafts/Events/Add/EventAdd"
import TitlesList from "@/views/Titles/Listing/Titles"
import TitleEdit from "@/views/Titles/Edit/TitleEdit"
import TitlesPreview from "@/views/Titles/Preview/TitlesPreview"
import Report from "@/views/Export/Report"
import Auth from "@/views/Account/Auth"
import NotFound from "@/views/Common/NotFound"
import JudgeApplication from "@/views/Judges/Application/JudgeApplication.vue"
import AdminJudgeAppsList from "@/views/Judges/Application/AdminJudgeAppsList.vue"
import JudgeAdminDashboard from "@/views/Judges/Admin/JudgeAdminDashboard.vue"
import AdminJudgesList from "@/views/Judges/Admin/AdminJudgesList.vue"
import Judges from "@/views/Judges/Listing/Judges"
import ExpressionInterest from "@/views/Judges/ExpressionOfInterest/ExpressionInterest"
import ActiveDrafts from "@/views/Judges/ExpressionOfInterest/ActiveDrafts"
import JudgeSecretaryDashboard from "@/views/Judges/Secretary/JudgeSecretaryDashboard"
import PendingExpressionInterest from "@/views/Judges/Secretary/PendingExpressionInterest"
import ApprovedExpressionInterest from "@/views/Judges/Secretary/ApprovedExpressionInterest"
import Survey from "@/views/Judges/Surveys/Survey"
import LeadersDrafts from "@/views/Leaders/Listing/Drafts"
import LeadersDraft from "@/views/Leaders/Listing/Draft"
import LeadersEvent from "@/views/Leaders/Listing/Event"
import LeadersDraftCutoutHighest from "@/views/Leaders/CutoutHighest/Draft"
import LeadersEventCutoutHighest from "@/views/Leaders/CutoutHighest/Event"
import ApiTokensList from "@/views/ApiTokens/Listing/ApiTokens"
import "./vars"
import JudgeDashboard from "../views/Judges/Dashboard/JudgeDashboard"
import CommitteeAffiliation from "../views/Committees/Affiliation/CommitteeAffiliation"
import CommitteeNotRegistered from "../views/Committees/Profile/components/CommitteeNotRegistered"
import CommitteeCart from "../views/Committees/Cart/Cart"
import CommitteePayment from "../views/Committees/Cart/Payment"
import CommitteeEditSecretary from "../views/Committees/Edit/CommitteeEditSecretary"
import useUserRole from '../composables/useUserRole'


Vue.use(Router)

const SecretaryDraftAdd = () => import('@/views/Drafts/Add/SecretaryDraftAdd')
const SecretaryDraftEdit = () => import('@/views/Drafts/Edit/SecretaryDraftEdit')
const SecretaryDraftView = () => import('@/views/Drafts/View/SecretaryDraftView')
const SecretaryEventCreate = () => import('@/views/Drafts/Events/SecretaryEventCreate')
const SecretaryEventEdit = () => import('@/views/Drafts/Events/SecretaryEventEdit')
const AppearanceEdit = () => import('@/views/Appearances/AppearanceEdit')
const Import = () => import('@/views/SuperAdmin/Import/Import')
const TermsAndConditions = () => import('@/views/Pages/TermsAndConditions/TermsAndConditions')
const CommitteeDashboard = () => import('@/views/Committees/Dashboard/CommitteeDashboard')
const NominationsDraftsList = () => import('@/views/Nominations/DraftsList')
const NominationsAdd = () => import('@/views/Nominations/NominationsAdd')
const HorseMerge = () => import('@/views/Horses/Merge/HorseMerge')

// Draws (step 4)
const DrawsDashboard = () => import('@/views/Draws/Dashboard/DrawsDashboard')
const DrawsPublic = () => import('@/views/Draws/Public/DrawsPublic')
const DrawsPublicList = () => import('@/views/Draws/PublicList/DrawsPublicList')
const DrawsEventView = () => import('@/views/Draws/View/DrawsEventView')
const DrawsResult = () => import('@/views/Draws/Results/DrawsResult')

// Nominations extras (step 4)
const NominationsBulkEmail = () => import('@/views/Nominations/BulkEmail/NominationsBulkEmail')
const NominationsReassign = () => import('@/views/Nominations/Reassign/NominationsReassign')

// Committees extras (step 4)
const CommitteesBulkMail = () => import('@/views/Committees/BulkMail/CommitteesBulkMail')

// Reports (step 4)
const ReportsIncoming = () => import('@/views/Reports/ReportsIncoming')
const ReportsOutgoing = () => import('@/views/Reports/ReportsOutgoing')

// Invoices (step 4)
const InvoicesList = () => import('@/views/Invoices/InvoicesList')

// Biosecurity (step 4)
const BiosecurityForm = () => import('@/views/Biosecurity/BiosecurityForm')

// Calculators (step 4)
const CalculatorView = () => import('@/views/Calculators/CalculatorView')

// Prizes (step 4)
const PrizesView = () => import('@/views/Prizes/PrizesView')
const PrizeSummaryView = () => import('@/views/Draws/PrizeSummary/PrizeSummaryView')

// Draft Event Members (step 4)
const DraftEventMembers = () => import('@/views/DraftEventMembers/DraftEventMembers')

// Competitors
const CompetitorsList = () => import('@/views/Competitors/CompetitorsList')

// BOY Status (affected results)
const AffectedResultsView = () => import('@/views/BoyStatus/AffectedResults/AffectedResultsView')


const routes = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      props: true,
      meta: {
        breadcrumb: [{ name: "Dashboard", link: "" }],
        showInNavar: true
      }
    },
    {
      path: '/committees/not-registered',
      name: "Committee Not Registered",
      props: true,
      component: CommitteeNotRegistered,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee" }
        ],
        showInNavar: false,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
        requiresAuth: ["Secretary", "SecretaryOnly"],
        childOf: "Committees"
      }
    },
    {
      path: '/committees/dashboard/:draftId?',
      name: "Committees Dashboard",
      displayName: "Committees",
      component: CommitteeDashboard,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee" }
        ],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: '/committees/dashboard',
      name: "Nomination Dashboard",
      component: CommitteeDashboard,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee" }
        ],
        showInNavar: true,
        childOf: "Committees Dashboard",
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: '/drafts/setup',
      name: "Draft Setup",
      component: SecretaryDraftAdd,
      meta: {
        showInNavar: true,
        childOf: "Committees Dashboard",
        requiresAuth: ["Secretary", "SecretaryOnly"],
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Create Draft" }]
      }
    },
    {
      path: '/drafts/view/:id',
      name: "Draft View",
      component: SecretaryDraftView,
      props: route => ({ draftId: route.params.id }),
      meta: {
        requiresAuth: ["Secretary", "SecretaryOnly"],
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Committee", link: "committees/dashboard" }, { name: "View Draft" }]
      }
    },
    {
      path: '/drafts/edit/:id',
      name: "Draft Edit",
      component: SecretaryDraftEdit,
      props: route => ({ draftId: route.params.id }),
      meta: {
        requiresAuth: ["Secretary", "SecretaryOnly"],
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Committee", link: "committees/dashboard" }, { name: "Edit Draft" }]
      }
    },
    {
      path: '/drafts/view/:id/events/add',
      name: "Event Create",
      component: SecretaryEventCreate,
      props: route => ({ draftId: route.params.id }),
      meta: {
        requiresAuth: ["Secretary", "SecretaryOnly"],
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Committee", link: "committees/dashboard" }, { name: "View Draft", link: "" }, { name: "Create Event" }]
      }
    },
    {
      path: '/drafts/view/:id/events/:eventId/edit',
      name: "Event Edit",
      component: SecretaryEventEdit,
      props: route => ({ draftId: route.params.id, eventId: route.params.eventId }),
      meta: {
        requiresAuth: ["Secretary", "SecretaryOnly"],
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Committee", link: "committees/dashboard" }, { name: "View Draft", link: "" }, { name: "Edit Event" }]
      }
    },
    {
      path: '/drafts/add-old',
      beforeEnter() { location.href = `${Vue.prototype.$coy}/drafts/add` },
      name: "Draft Setup Old",
      meta: {
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: '/committees/edit',
      name: "Committee",
      component: CommitteeEditSecretary,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committees" }
        ],
        showInNavar: true,
        childOf: "Committees Dashboard",
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: '/committees/affiliation',
      name: "Committee Affiliation",
      props: true,
      component: CommitteeAffiliation,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee" }
        ],
        showInNavar: false,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
        requiresAuth: ["Secretary", "SecretaryOnly"],
        childOf: "Committees"
      }
    },
    {
      path: "/committees/cart",
      name: "Committee Cart",
      component: CommitteeCart,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee", link: "committees/affiliation" },
          { name: "Cart", link: "committees/cart" }
        ],
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/committees/payment",
      name: "Committee Payment",
      component: CommitteePayment,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee", link: "committees/affiliation" },
          { name: "Cart", link: "committees/payment" }
        ],
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: '/draws/view',
      redirect: '/draws/dashboard',
      meta: { showInNavar: false }
    },
    {
      path: '/draws/dashboard',
      name: 'DrawsDashboard',
      displayName: 'Draws Dashboard',
      component: DrawsDashboard,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws Dashboard' }],
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        childOf: 'Committees Dashboard',
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/draws/public/:eventId/:round',
      name: 'DrawsPublic',
      component: DrawsPublic,
      meta: {
        breadcrumb: [{ name: 'Draws', link: 'draws/public' }, { name: 'Draw Results' }],
        requiresAuth: null
      }
    },
    {
      path: '/draws/results/:eventId/:round',
      name: 'DrawsResult',
      component: DrawsResult,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws Dashboard', link: 'draws/dashboard' }, { name: 'Round Results' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/draws/:draftId/:eventId/:round',
      name: 'DrawsEventView',
      component: DrawsEventView,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws Dashboard', link: 'draws/dashboard' }, { name: 'Event' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/competitors',
      name: 'Competitors',
      component: CompetitorsList,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '' },
          { name: 'Competitors' }
        ],
        showInNavar: true,
        childOf: 'Committees Dashboard',
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: "/secretary-horses",
      name: "Horses",
      component: HorsesListing,
      props: true,
      meta: {
        horseList: {
          title: "Horses",
          variant: "secretary",
          profileRoute: "Secretary Horse Profile",
          addRoute: "Secretary Add Horses"
        },
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
        showInNavar: true,
        childOf: "Committees Dashboard",
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/secretary-horses/:slug",
      name: "Secretary Horse Profile",
      component: HorseProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "secretary-horses" },
          { name: "Horse Profile", link: "secretary-horses/horse-profile" }
        ],
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/secretary-add-horse",
      name: "Secretary Add Horses",
      component: HorseAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "secretary-horses" },
          { name: "Add Horse", link: "secretary-add-horse" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/switch-committee",
      name: "Switch Committee",
      component: SwitchCommittee,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Switch Committee" }
        ],
        showInNavar: true,
        requiresSuperSecretary: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
        requiresAuth: ["Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/export-reports",
      name: "Export Reports",
      component: Report,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Export Reports" }
        ],
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="24" height="24"><g><path fill="currentColor" d="M7.5 9.5c-.1 0-.3 0-.4-.1l-3-3c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.6 2.6L10 5.7c.2-.2.5-.2.7 0s.2.5 0 .7l-3 3c.1.1-.1.1-.2.1z"/><path fill="currentColor" d="M7.5 9c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5s.5.2.5.5v8c0 .3-.2.5-.5.5z"/><g><path fill="currentColor" d="M12.5 15h-10C1.1 15 0 13.9 0 12.5v-2c0-.3.2-.5.5-.5s.5.2.5.5v2c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5v-2c0-.3.2-.5.5-.5s.5.2.5.5v2c0 1.4-1.1 2.5-2.5 2.5z"/></g></g></svg>'
      }
    },
    {
      path: "/my-account",
      name: "My Profile",
      component: MyMembershipProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Profile", link: "my-account" }
        ],
        icon:
          '<svg width="24" height="19" viewBox="-42 0 512 512.001" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0"/><path fill="currentColor" d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0"/></svg>',
        showInNavar: true,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Volunteer"]
      }
    },
    {
      path: '/invoices',
      name: 'InvoicesList',
      component: InvoicesList,
      displayName: 'My Invoices',
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Invoices' }],
        showInNavar: true,
        childOf: 'Nominations',
        requiresAuth: ['Member', 'Secretary', 'Volunteer']
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      props: true,
      meta: {
        breadcrumb: [{ name: "Log In" }],
        requiresAuth: null
      }
    },
    {
      path: "/maintenance",
      name: "Maintenance",
      component: Maintenance,
      meta: {
        breadcrumb: [{ name: "Maintenance" }],
        requiresAuth: null
      }
    },
    {
      path: "/members",
      name: "Members",
      component: Members,
      meta: {
        memberList: { title: "Members" },
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Members" }],
        requiresAuth: ["Secretary", "SecretaryOnly"],
        showInNavar: true,
        childOf: "Committees Dashboard",
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
      }
    },
    {
      path: "/admin-members",
      name: "Members ",
      component: Members,
      meta: {
        memberList: { title: "Members" },
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Members" }],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
      }
    },
    {
      path: "/admin-register",
      name: "Register Member ",
      component: AdminRegister,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Register Member" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
      }
    },
    {
      path: "/members/:slug/merge",
      name: "Merge Member",
      props: true,
      component: MemberMerge,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile", params: { slug: true } },
          { name: "Merge Member" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/members/:slug",
      name: "Member Profile",
      props: true,
      component: MemberProfileMembers,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile" }
        ],
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/members/:entityId/boy-status-history/:stateId/affected-results",
      name: "Member BOY Affected Results",
      component: AffectedResultsView,
      props: route => ({ type: "rider", entityId: route.params.entityId, stateId: route.params.stateId }),
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile", link: "members/member-profile" },
          { name: "Affected Results" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/registrations-pending/horse",
      name: "Pending Horse",
      props: true,
      component: PendingHorse,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Pending Horse Updates", link: "registrations-pending" },
          { name: "Pending Horse" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/members/member-profile/member-profile-child",
      name: "Member Profile Child",
      props: true,
      component: MemberProfileChild,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile", link: "members/member-profile" },
          { name: "Member Profile Child" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/members/member-profile/join-members",
      name: "Join Members",
      component: MemberJoin,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile", link: "members/member-profile" },
          { name: "Join Members", link: "/members/member-profile/join-members" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/my-account/user-details",
      name: "My Membership Child",
      component: MyMembershipProfileChild,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Profile", link: "my-account" },
          { name: "Account Details", link: "my-account/user-details" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/my-account/cart",
      name: "My Membership Cart",
      component: MyMembershipCart,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Profile", link: "my-account" },
          { name: "Cart", link: "my-account/cart" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/my-account/payment",
      name: "My Membership Payment",
      component: MyMembershipPayment,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Profile", link: "my-account" },
          { name: "Payment", link: "my-account/payment" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/judges/application/:member_id?",
      name: "Judge Application",
      component: JudgeApplication,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          {
            name: "Judge Application"
          }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: false,
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/judges/dashboard",
      name: "Judges Dashboard",
      component: JudgeDashboard,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          {
            name: "Judge Application"
          }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: true,
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/judges/admin-dashboard",
      name: "Judges",
      component: JudgeAdminDashboard,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Admin Judge Dashboard" }
        ],
        icon: '<svg width="24" height="24" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/judges/admin-judges-list",
      name: "Judges list",
      component: AdminJudgesList,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Admin Judge Dashboard", link: "judges/admin-dashboard" },
          { name: "Judges list", link: "" }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/judges/admin-apps-list",
      name: "Admin Judges Applications List",
      component: AdminJudgeAppsList,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          {
            name: "Admin Judges Applications List"
          }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/judges-list",
      name: "Public Judges List",
      component: Judges,
      props: true,
      meta: {
        requiresAuth: null
      }
    },
    {
      path: "/judges/:slug/expression-interest",
      name: "Expression Of Interest",
      component: ExpressionInterest,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Judge Dashboard", link: "judges/dashboard" },
          { name: "Expression Of Interest", link: "" }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: false,
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/judges/:slug/active-drafts",
      name: "Active Drafts",
      component: ActiveDrafts,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Judge Dashboard", link: "judges/dashboard" },
          { name: "Active Drafts", link: "" }
        ],
        icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin"]
      }
    },
    {
      path: "/judges/secretary-dashboard",
      name: "Judges Secretary Dashboard",
      displayName: "Judges",
      component: JudgeSecretaryDashboard,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Secretary Judges Dashboard", link: "" }
        ],
        showInNavar: true,
        requiresAuth: ["Secretary", "SecretaryOnly"],
        childOf: "Committees Dashboard"
      }
    },
    {
      path: "/judges/secretary/expression-interest/pending",
      name: "Pending Expression Of Interest",
      component: PendingExpressionInterest,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Secretary Judges Dashboard", link: "judges/secretary-dashboard" },
          { name: "Pending Expression Of Interest", link: "" }
        ],
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"],
        childOf: "Committees"
      }
    },
    {
      path: "/judges/secretary/expression-interest/approved",
      name: "Approved Expression Of Interest",
      component: ApprovedExpressionInterest,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Secretary Judges Dashboard", link: "judges/secretary-dashboard" },
          { name: "Approved Expression Of Interest", link: "" }
        ],
        showInNavar: false,
        requiresAuth: ["Secretary", "SecretaryOnly"],
        childOf: "Committees"
      }
    },
    {
      path: "/judges/survey",
      name: "Judge Survey",
      component: Survey,
      props: false,
      meta: {
        breadcrumb: [
          { name: "Judge Survey", link: "" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/horses",
      name: "My Horses",
      component: HorsesListing,
      props: true,
      meta: {
        horseList: {
          title: "My Horses",
          variant: "member",
          profileRoute: "Horse Profile",
          addRoute: "Add Horse"
        },
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Horses" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
        showInNavar: true,
        requiresAuth: ["Member", "Secretary", "Volunteer"]
      }
    },
    {
      path: '/draws/public',
      name: 'DrawsPublicList',
      component: DrawsPublicList,
      displayName: 'Draws',
      meta: {
        breadcrumb: [{ name: 'Draws' }],
        showInNavar: true,
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        requiresAuth: ['Member', 'Volunteer', 'Secretary', 'SecretaryOnly']
      }
    },
    {
      path: "/admin-horses",
      name: "Horses",
      component: HorsesListing,
      props: true,
      meta: {
        horseList: {
          title: "Horses",
          variant: "admin",
          profileRoute: "Admin Horse Profile",
          addRoute: "Add Horses"
        },
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: '/draws',
      redirect: '/draws/dashboard',
      meta: { showInNavar: false }
    },
    {
      path: '/leaders/drafts',
      name: "Leaderboard",
      props: true,
      component: LeadersDrafts,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
      }
    },
    {
      path: '/leaders/drafts/:draft_id',
      name: 'LeadersDraft',
      component: LeadersDraft,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard", link: "leaders/drafts" },
          { name: "Draft" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
      }
    },
    {
      path: '/leaders/drafts/:draft_id/cutout-highest',
      name: 'LeadersDraftCutoutHighest',
      component: LeadersDraftCutoutHighest,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard", link: "leaders/drafts" },
          { name: "Draft" },
          { name: "Cutout Highest" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin"]
      }
    },
    {
      path: '/leaders/events/:event_id/cutout-highest/:round?',
      name: 'LeadersEventCutoutHighest',
      component: LeadersEventCutoutHighest,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard", link: "leaders/drafts" },
          { name: "Draft" },
          { name: "Event" },
          { name: "Cutout Highest" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin"]
      }
    },
    {
      path: '/leaders/events/:main_event_id/:round?/:sub_event_id?',
      name: 'LeadersEvent',
      component: LeadersEvent,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard", link: "leaders/drafts" },
          { name: "Draft" },
          { name: "Event" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
      }
    },
    {
      path: '/leaders-old',
      beforeEnter() { location.href = `${Vue.prototype.$coy}/leaders` },
      name: "Leaderboard old",
      meta: {
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
      }
    },
    {
      path: '/nominations',
      name: "Nominations",
      component: NominationsDraftsList,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Nominations' }],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        requiresAuth: ["Member", "Secretary", "Volunteer", "SecretaryOnly", "Admin", "SuperAdmin"]
      }
    },
    {
      path: '/nominations/add/:draftId',
      name: 'Nominations Add',
      component: NominationsAdd,
      props: route => ({ draftId: route.params.draftId }),
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Nominations', link: 'nominations' }, { name: 'Nominate' }],
        requiresAuth: ['Member', 'Secretary', 'Volunteer', 'SecretaryOnly', 'Admin', 'SuperAdmin']
      }
    },
    {
      path: '/reports/incoming',
      name: 'ReportsIncoming',
      displayName: 'Reports',
      component: ReportsIncoming,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Reports' }],
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        childOf: 'Committees Dashboard',
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/reports/outgoing',
      name: 'ReportsOutgoing',
      component: ReportsOutgoing,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Reports' }],
        showInNavar: false,
        childOf: 'Committees Dashboard',
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: "/add-horse",
      name: "Add Horses",
      component: HorseAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "admin-horses" },
          { name: "Add Horse", link: "add-horse" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/registrations-pending",
      name: "Horse Updates",
      props: true,
      component: PendingRegistrations,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Pending Horse Updates" }
        ],
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin"],
        childOf: "Horses"
      }
    },
    {
      path: "/horses/add-horse",
      name: "Add Horse",
      component: HorseAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Horses", link: "horses" },
          { name: "Add Horse", link: "horses/add-horse" }
        ],
        showInNavar: false,
        childOf: "Horses",
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly", "Volunteer"]
      }
    },
    {
      // Numeric constraint so sibling static routes (/horses/add-horse, /horses/register-horse,
      // /horses/nominate-rookie) resolve to their own page instead of being read as a slug —
      // which is what breaks "open in a new tab" on those links.
      path: "/horses/:slug(\\d+)",
      name: "Horse Profile",
      component: HorseProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Horses", link: "horses" },
          { name: "Horse Profile", link: "horses/horse-profile" }
        ],
        showInNavar: false,
        requiresAuth: null
      }
    },
    {
      path: "/horses/:entityId/boy-status-history/:stateId/affected-results",
      name: "Horse BOY Affected Results",
      component: AffectedResultsView,
      props: route => ({ type: "horse", entityId: route.params.entityId, stateId: route.params.stateId }),
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Horses", link: "horses" },
          { name: "Horse Profile", link: "horses/horse-profile" },
          { name: "Affected Results" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/admin-horses/:slug/merge",
      name: "Merge Horse",
      component: HorseMerge,
      props: route => ({ sourceHorseId: route.params.slug }),
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "admin-horses" },
          { name: "Admin Horse Profile", params: { slug: true } },
          { name: "Merge Horse" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/admin-horses/:slug",
      name: "Admin Horse Profile",
      component: HorseProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "admin-horses" },
          { name: "Horse Profile", link: "admin-horses/horse-profile" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/admin-horses/add-horse",
      name: "Admin Add Horse",
      component: HorseAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "admin-horses" },
          { name: "Add Horse", link: "admin-horses/add-horse" }
        ],
        showInNavar: false,
        childOf: "Horses",
        requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/register-horse",
      name: "Register Horse",
      component: HorseRegister,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Register Horse", link: "horses/register-horse" }
        ],
        showInNavar: false,
        childOf: "Horses",
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/horses/nominate-rookie",
      name: "Nominate Rookie",
      component: RookieNominations,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Nominate Rookie", link: "horses/nominate-rookie" }
        ],
        showInNavar: false,
        childOf: "Horses",
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/register-horse/confirm",
      name: "Confirm Horse",
      component: HorseConfirm,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Register Horse", link: "horses/register-horse" },
          { name: "Confirm Horse", link: "horses/register-horse/confirm" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/nominate-rookie/confirm",
      name: "Confirm Rookie Status",
      component: HorseConfirm,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Nominate Rookie", link: "horses/nominate-rookie" },
          {
            name: "Confirm Rookie Status",
            link: "horses/nominate-rookie/confirm"
          }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/register-horse/cart",
      name: "Register Horse Cart",
      component: HorseRegisterCart,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Register Horse", link: "horses/register-horse" },
          { name: "Cart", link: "horses/register-horse/cart" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/nominate-rookie/cart",
      name: "Nominate Rookie Cart",
      component: HorseRegisterCart,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Nominate Rookie", link: "horses/nominate-rookie" },
          { name: "Cart", link: "horses/nominate-rookie/cart" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/horses/register-horse/cart/payment",
      name: "Register Horse Payment",
      component: HorseRegisterPayment,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Register Horse", link: "horses/register-horse" },
          { name: "Cart", link: "horses/register-horse/cart" },
          { name: "Payment", link: "horses/register-horse/cart/payment" }
        ],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary"]
      }
    },
    {
      path: "/horses/nominate-rookie/cart/payment",
      name: "Nominate Rookie Payment",
      component: HorseRegisterPayment,
      props: true,
      meta: {
        cartFlow: true,
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Horses", link: "horses" },
          { name: "Nominate Rookie", link: "horses/nominate-rookie" },
          { name: "Cart", link: "horses/nominate-rookie/cart" },
          { name: "Payment", link: "horses/nominate-rookie/cart/payment" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/drafts-list",
      name: "Drafts",
      props: true,
      component: DraftsList,
      meta: {
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Drafts List" }],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 32.182 27.092"><g id="fence" transform="translate(-862 -273.796)"><path id="Path_7252" data-name="Path 7252" d="M28.32,91.095h-4.6a.663.663,0,0,1-.663-.664V67.109a.664.664,0,0,1,.168-.441L25.4,64.227A.664.664,0,0,1,25.873,64a.635.635,0,0,1,.488.2l2.429,2.441a.663.663,0,0,1,.193.468V90.431A.664.664,0,0,1,28.32,91.095Zm-3.938-1.328h3.274V67.383l-1.738-1.747-1.536,1.725Z" transform="translate(841.187 209.793)" fill="currentColor"/><path id="Path_7253" data-name="Path 7253" d="M102.684,91.091H98a.664.664,0,0,1-.664-.664V67.105a.663.663,0,0,1,.172-.445l2.21-2.441A.662.662,0,0,1,100.2,64a.642.642,0,0,1,.485.191l2.469,2.441a.666.666,0,0,1,.2.472V90.427A.664.664,0,0,1,102.684,91.091Zm-4.016-1.328h3.352V67.382l-1.779-1.758-1.573,1.737Z" transform="translate(774.124 209.797)" fill="currentColor"/><path id="Path_7254" data-name="Path 7254" d="M178.331,91.1H173.71a.664.664,0,0,1-.663-.664V67.11a.661.661,0,0,1,.169-.442l2.182-2.441a.662.662,0,0,1,.476-.221.639.639,0,0,1,.488.194l2.438,2.441a.662.662,0,0,1,.194.469V90.432A.664.664,0,0,1,178.331,91.1Zm-3.957-1.328h3.293V67.385l-1.748-1.75-1.545,1.728Z" transform="translate(705.778 209.792)" fill="currentColor"/><path id="Path_7255" data-name="Path 7255" d="M252.7,91.094H248a.664.664,0,0,1-.664-.664V67.108a.662.662,0,0,1,.172-.446l2.219-2.441A.665.665,0,0,1,250.2,64a.657.657,0,0,1,.483.191l2.479,2.441a.662.662,0,0,1,.2.473V90.43A.664.664,0,0,1,252.7,91.094Zm-4.034-1.328h3.371V67.387l-1.789-1.761-1.582,1.74Z" transform="translate(638.708 209.794)" fill="currentColor"/><path id="Path_7256" data-name="Path 7256" d="M31.642,276.241H.54a.678.678,0,0,1,0-1.327h31.1a.678.678,0,0,1,0,1.327Z" transform="translate(862 19.389)" fill="currentColor"/><path id="Path_7257" data-name="Path 7257" d="M33.026,112.5H2.259a.678.678,0,0,1,0-1.327H33.026a.678.678,0,0,1,0,1.327Z" transform="translate(860.448 167.215)" fill="currentColor"/></g></svg>',
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/drafts-list/draft-create",
      name: "Create Draft",
      props: true,
      component: DraftCreate,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Drafts List", link: "drafts-list" },
          { name: "Create Draft" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/drafts-list/:draftId/edit",
      name: "Edit Draft",
      props: true,
      component: DraftCreate,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Drafts List", link: "drafts-list" },
          { name: "Edit Draft" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/drafts-list/:draftId/events-list",
      name: "Events",
      props: true,
      component: EventsList,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Drafts List", link: "drafts-list" },
          { name: "Placeholder" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/drafts-list/:draftId/events-list/event-create/:eventId?",
      name: "Create Event",
      props: true,
      component: EventCreate,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Drafts List", link: "drafts-list" },
          { name: "Placeholder", link: "placeholder", routeName: "Events" },
          { name: "Create Event" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/titles-list",
      name: "Titles",
      props: true,
      component: TitlesList,
      meta: {
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Titles List" }],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/titles-list/title-edit",
      name: "Edit Title",
      props: true,
      component: TitleEdit,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Titles List", link: "titles-list" },
          { name: "Edit Title" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/titles-preview",
      name: "Preview Standings",
      component: TitlesPreview,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Preview Standings" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        childOf: "Titles"
      }
    },
    {
      path: "/committee-list",
      name: "Committees",
      props: true,
      component: CommitteeList,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee List" }
        ],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: '/nominations/:draftId/bulk-email',
      name: 'NominationsBulkEmail',
      component: NominationsBulkEmail,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Nominations', link: 'nominations' }, { name: 'Bulk Email' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/nominations/:draftId/reassign-:type',
      name: 'NominationsReassign',
      component: NominationsReassign,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws', link: 'draws/dashboard' }, { name: 'Reassign' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/committees/:draftId/bulk-mail',
      name: 'CommitteesBulkMail',
      component: CommitteesBulkMail,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Committees', link: 'committees/dashboard' }, { name: 'Bulk Mail' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/biosecurity/:draftId',
      name: 'BiosecurityForm',
      component: BiosecurityForm,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Nominations', link: 'nominations' }, { name: 'Biosecurity' }],
        requiresAuth: ['Member', 'Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/calculators/:eventId',
      name: 'CalculatorView',
      component: CalculatorView,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws', link: 'draws/dashboard' }, { name: 'Calculator' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/prizes/:eventId',
      name: 'PrizesView',
      component: PrizesView,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws', link: 'draws/dashboard' }, { name: 'Prizes' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/drafts/:draftId/prize-summary',
      name: 'PrizeSummaryView',
      component: PrizeSummaryView,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Draws', link: 'draws/dashboard' }, { name: 'Prize Money Summary' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: '/draft-members/:draftId',
      name: 'DraftEventMembers',
      component: DraftEventMembers,
      meta: {
        breadcrumb: [{ name: 'Dashboard', link: '' }, { name: 'Committees', link: 'committees/dashboard' }, { name: 'Event Members' }],
        requiresAuth: ['Secretary', 'SecretaryOnly']
      }
    },
    {
      path: "/committees/bulk-mailing",
      name: "Bulk Mailing",
      component: CommitteesBulkMail,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committees Bulk Mailing" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        childOf: "Committees"
      }
    },
    {
      path: "/committee-list/committee-profile/:id?",
      name: "Committee Profile",
      props: true,
      component: CommitteeProfile,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Committee List", link: "committee-list" },
          { name: "Committee Profile" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/secretary-users",
      name: "Secretary Users",
      component: SecretaryUsers,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Secretary Users" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
      }
    },
    {
      path: "/admin-users",
      name: "Admin Users",
      component: AdminUsers,
      props: true,
      meta: {
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Admin Users" }],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 16 13" width="24" height="20"><g class="currentLayer" fill="currentColor"><g><path d="M13.3 12.8H2.8c-.8 0-1.5-.6-1.5-1.4L.6 5.1c0-.2.1-.4.3-.5.2-.1.5 0 .6.2.9 1.3 2.2 2.8 2.7 2.8.6 0 2.2-2.9 3.3-6 .1-.4.8-.4.9 0 1.1 3.2 2.7 6 3.3 6 .5 0 1.8-1.4 2.8-2.8.1-.2.4-.3.6-.2.2.1.3.3.3.5l-.6 6.3c-.1.8-.8 1.4-1.5 1.4zm-11.6-6l.5 4.5c0 .3.3.5.5.5h10.5c.3 0 .5-.2.5-.5l.5-4.5c-.7.9-1.7 1.8-2.5 1.8-1.4-.1-3-3.4-3.8-5.5-.8 2.1-2.4 5.3-3.7 5.5-.7 0-1.7-.9-2.5-1.8z"/><circle cx="1" cy="5.1" r="1"/><circle cx="8" cy="1" r="1"/><circle cx="15" cy="5.1" r="1"/><g><circle cx="8" cy="9.5" r="1"/></g></g></g></svg>'
      }
    },
    {
      path: "/admin-users/admin-profile",
      name: "Admin Profile",
      component: AdminProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Admin Users", link: "admin-users" },
          { name: "Admin User Profile", link: "admin-users/admin-profile" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/secretary-users/:slug",
      name: "Secretary Profile",
      component: SecretaryProfile,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Secretary Users", params: { slug: true } },
          {
            name: "Secretary User Profile",
            link: "secretary-users/secretary-profile"
          }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/admin-users/admin-profile/member-profile",
      name: "Admin Profile Child",
      component: AdminProfileChild,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Admin Users", link: "admin-users" },
          { name: "Admin User Profile", link: "admin-users/admin-profile" },
          {
            name: "User Profile",
            link: "admin-users/admin-profile/member-profile"
          }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/members/member-profile/split",
      name: "Member Profile Split",
      component: MemberSplit,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Members", link: "members" },
          { name: "Member Profile", link: "members/member-profile" },
          { name: "Split Member Profile", link: "members/member-profile/split" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/my-account/add",
      name: "Add Members",
      component: MemberAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "My Profile", link: "my-account" },
          { name: "Add" }
        ],
        showInNavar: false,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/admin-users/add",
      name: "Add Admin Members",
      component: MemberAdminAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Admin Users", link: "admin-users" },
          { name: "Add Admin" }
        ],
        showInNavar: false
      }
    },
    {
      path: "/secretary-users/add",
      name: "Add Secretary Members",
      component: SecretaryAdd,
      props: true,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Secretary Users", link: "secretary-users" },
          { name: "Add Secretary" }
        ],
        showInNavar: false
      }
    },
    {
      path: "/invoices-pending",
      name: "Payments",
      props: true,
      component: PendingInvoices,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Invoices Pending" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true,
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 17 12" width="24" height="17"><g><path fill="currentColor" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="currentColor" d="M.5 2.2999992h16v1H.5zM.5 4.1000004h16v1H.5zM5.2 7.4H2.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.6c.3 0 .5.2.5.5s-.2.5-.5.5zM8.7 9.5H2.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.1c.3 0 .5.2.5.5s-.3.5-.5.5z"/></g></svg>'
      }
    },
    {
      path: "/pages/termsAndConditions",
      name: "ACA Terms & Conditions",
      component: TermsAndConditions,
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "ACA Terms & Conditions" }
        ],
        requiresAuth: ["Admin", "SuperAdmin"],
        showInNavar: true
      }
    },
    {
      path: '/leaderboardAppearance',
      name: "Leaderboard Appearance",
      component: AppearanceEdit,
      props: { frame: 'leaderboard' },
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Leaderboard Appearance" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: '/nominationAppearance',
      name: "Nominations Appearance",
      component: AppearanceEdit,
      props: { frame: 'nominations' },
      meta: {
        breadcrumb: [
          { name: "Dashboard", link: "" },
          { name: "Nominations Appearance" }
        ],
        icon:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
        showInNavar: true,
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: "/api-tokens",
      name: "Access API Tokens",
      props: true,
      component: ApiTokensList,
      meta: {
        breadcrumb: [{ name: "Dashboard", link: "" }, { name: "Access API Tokens" }],
        showInNavar: true,
        icon:
          '<svg width="24" height="24" viewBox="144 144 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="m412.84 319.58c-18.125-.75-33.98 12.082-39.27 29.449-3.0195 9.8164 12.082 13.594 14.348 3.7734 3.0195-10.57 13.594-18.125 24.922-18.125 11.328.0 21.145 7.5508 24.164 18.879s-2.2656 22.656-12.836 28.695h-.75391-61.168c-8.3086.0-15.102 6.7969-15.102 15.105v67.961c0 8.3086 6.7969 15.105 15.102 15.105h75.516c8.3086.0 15.102-6.7969 15.102-15.105v-67.961c0-5.2891-3.7773-10.574-8.3086-13.594 6.7969-9.0625 9.8164-21.145 6.7969-33.23-3.7773-18.125-19.633-30.961-38.512-30.961zm-50.594 77.781s-.75391.0.0.0h75.516v67.961h-75.516z"/><path d="m400.75 238.78c-2.2656.0-4.5312 1.5-6.043 3.7734-13.594 19.637-57.391 37.004-107.23 37.004h-.75391-.75391c-3.7773.0-6.7969 2.2461-7.5508 6.0391.0.0-7.5508 33.98-11.328 74.762-3.7773 41.535-4.5312 89.105 12.082 120.82 12.082 22.656 41.535 41.535 67.965 55.883 24.918 13.594 45.309 21.898 48.328 22.656 1.5117.75 3.0195 1.5 4.5312 1.5s3.0195-.75 4.5312-1.5c2.2656-.75 23.41-9.0625 47.574-22.656 26.43-14.348 55.879-33.23 68.719-55.883 16.613-31.719 15.859-79.289 12.082-120.82-3.7773-40.777-11.328-74.762-11.328-74.762-.75391-3.7734-4.5312-6.0391-8.3086-6.0391-48.328.0-90.617-16.613-104.96-35.492-1.5117-3.0312-4.5312-5.2891-7.5508-5.2891zm0 19.633c21.145 22.656 61.922 34.738 106.48 36.246 1.5117 6.7969 6.7969 32.473 10.57 67.207 3.7773 40.027 3.0195 86.844-10.57 111.77-9.0625 17.367-37.004 36.246-61.922 50.594-23.41 12.082-41.535 19.637-45.309 21.145-3.7773-1.5-22.656-9.0625-45.309-21.145-25.676-14.344-52.859-33.227-61.922-50.594-13.594-24.922-14.348-71.738-10.57-111.77 3.0195-34.734 8.3047-60.41 9.8164-67.207 46.062-1.5 87.598-13.594 108.74-36.246z"/></g></svg>',
        requiresAuth: ["Admin", "SuperAdmin"]
      }
    },
    {
      path: '/import',
      name: 'Import',
      component: Import,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', link: '' },
          { name: 'Import' }
        ],
        showInNavar: true,
        requiresAuth: ['SuperAdmin']
      }
    },
    {
      path: "/login-once",
      name: "Login Once",
      component: LoginOnce,
      props: true,
      meta: {
        breadcrumb: [{ name: "Login Once" }],
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "SecretaryOnly"]
      }
    },
    {
      path: "/login",
      name: "Log Out",
      component: Login,
      meta: {
        breadcrumb: [{ name: "Log Out" }],
        showInNavar: true
      }
    },
    {
      path: "/auth/getAccessToken",
      name: "Get Access Token",
      component: Auth,
      meta: {
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin", "SecretaryOnly", "Volunteer"]
      }
    },
    {
      path: '*',
      name: 'Not Found',
      component: NotFound,
      meta: {
        showInNavar: false,
        requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin", "SecretaryOnly", "Volunteer"]
      }
    }
  ]
})

routes.beforeEach(async (to, from, next) => {
  const { role, isUser, isAdmin, isSuperSecretary } = useUserRole()
  if (to.meta.requiresSuperSecretary && !isSuperSecretary) {
    next({ path: "/" })
  } else if (
    (localStorage.role === undefined &&
      to.name !== "Login" &&
      to.name !== "Maintenance" &&
      to.name !== "Public Judges List" &&
      to.name !== "Register") ||
    (isUser &&
      to.name !== "Login Once" &&
      to.name !== "Login" &&
      localStorage.is_onboarded !== "true")
  ) {
    next({ path: "/login" })
  } else if (to.name === "My Profile" && isAdmin) {
    next({ path: "/admin-members" })
  } else if (
    to.matched.some(
      record =>
        record.meta.requiresAuth !== null &&
        (record.meta.requiresAuth &&
          !record.meta.requiresAuth.includes(role))
    )
  ) {
    next({
      path: "/login",
      query: to.fullPath === "/" ? "" : { redirect: to.fullPath }
    })
  } else if (to.path === "/mail-list" || to.path === "/registered-users-list") {
    /* Back to dashboard if a user accesses these paths directly */
    next({ path: "/" })
  } else {
    /* The cart is only valid inside the cart/payment flow — drop it on any other page so it never leaks between members/horses/committees */
    if (!to.matched.some(record => record.meta.cartFlow) && Object.keys(store.state.cartMembers).length > 0) {
      store.commit('updateCartMembers', {})
    }
    next()
  }
})

/* After a deploy the old chunks are gone, so a tab running the previous build fails to lazy-load a route chunk.
   Reload once straight to the target route to pick up the new build; the timestamp guard prevents a reload loop
   if the chunk is really unreachable (offline, blocked). */
routes.onError((error, to) => {
  const isChunkError = /Loading (CSS )?chunk [\w-]+ failed/i.test(error && error.message)
  if (!isChunkError) return

  try {
    const lastReload = Number(sessionStorage.getItem("chunk_reload_at")) || 0
    if (Date.now() - lastReload < 30000) return
    sessionStorage.setItem("chunk_reload_at", String(Date.now()))
  } catch (e) {
    return
  }
  window.location.assign(to ? to.fullPath : window.location.href)
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js